var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "content-box", attrs: { "data-app": "" } },
    [
      _c("v-data-table", {
        staticClass: "elevation-2",
        staticStyle: { width: "100%" },
        attrs: {
          headers: _vm.headers,
          items: _vm.selectedResults,
          "item-key": "object_uuid",
          loading: _vm.loading,
          "loading-text": "",
          "items-per-page-text": _vm.$t("tables.RowsPerPage"),
          "items-per-page-items": [
            5,
            10,
            25,
            { text: _vm.$t("All"), value: -1 }
          ],
          "header-props": { sortIcon: "mdi-menu-down" },
          "footer-props": {
            prevIcon: "mdi-menu-left",
            nextIcon: "mdi-menu-right"
          },
          value: _vm.selected
        },
        scopedSlots: _vm._u([
          {
            key: "item",
            fn: function(props) {
              return [
                _c("tr", [
                  _c("td", [_vm._v(_vm._s(props.item.object_type_label))]),
                  _vm._v(" "),
                  _c("td", [_vm._v(_vm._s(props.item.object_id))]),
                  _vm._v(" "),
                  _c("td", [_vm._v(_vm._s(props.item.error_message))]),
                  _vm._v(" "),
                  _c(
                    "td",
                    { staticClass: "location-icon-container" },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { icon: "", text: "", color: "accent" },
                          on: {
                            click: function($event) {
                              return _vm.viewInMap(props.item)
                            }
                          }
                        },
                        [_c("v-icon", [_vm._v("gps_fixed")])],
                        1
                      )
                    ],
                    1
                  )
                ])
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-339c3e0f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-339c3e0f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Content/Tabs/Validations/ErrorSelection/ErrorSelection.vue
// module id = null
// module chunks = 